// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b6222a5e","239":"db5c45e2","455":"f10ac403"}[chunkId] + ".chunk.js";
};